import { useContext, useEffect, useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/Authcontext";
import { toast } from "sonner";
import LogoLoader from "../components/Loader/LogoLoader";

const ProtectedRoute = ({ children }) => {
  const { token, loading, emailVerify, phoneVerify } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!loading && token && emailVerify !== null && phoneVerify !== null && location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [loading, token, emailVerify, phoneVerify, location.pathname, navigate]);

  if (loading || showLoader) {
    return <LogoLoader />;
  }

  if (!token) {
    if (!hasShownToast.current) {
      toast.error("You are not logged in.");
      hasShownToast.current = true;
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (emailVerify === null || phoneVerify === null) {
    if (!hasShownToast.current) {
      toast.error("Please verify your email and phone number.");
      hasShownToast.current = true;
    }
    return null;
  }

  return children;
};

export default ProtectedRoute;
